import React, { useMemo, useState, useEffect } from 'react';
import { useTable, useFilters, useGlobalFilter, useSortBy } from 'react-table'
import AMonth from "./AMonth-json.json"
import { ColumnHead } from './ColumnHead_new';
import './MonthlyTable1.css';
import ColumnFilter from "./ColumnFilter";
import Spinner from 'react-bootstrap/Spinner';
import Modal from '@material-ui/core/Modal'
import TablePagination from '@mui/material/TablePagination';

function MonthlyTable1(props) {
  const columns = useMemo(() => ColumnHead, []);
  const [searchEvent, setSearchEvent] = useState('');
  const [columnEvent, setColumnEvent] = useState();
  const [checkboxData, setCheckBoxData] = useState([]);
  const [tableFilterData, setTableFilterData] = useState([])
  const [checkboxTableFilterData, setCheckboxTableFilterData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [modelOpen, setModelOpen] = useState();
  const [inputChange, setInputChange] = useState("");
  const [resetTableData, setResetTableData] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const data = props.data;
  console.log(data)
  const noData = data.length === 0;
  const handleOpen = () => {
    setModelOpen(true);
  };
  const handleClose = () => {
    setModelOpen(false);
  };
  const tableInstance = useTable(
    { columns, data },
    useGlobalFilter,
    useSortBy,
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    state,
  } = tableInstance;

  const handlePageChange = (event, newPage) => {
    setPageNumber(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPageNumber(0);
  };
  const DATA = data.slice(pageNumber * rowsPerPage, pageNumber * rowsPerPage + rowsPerPage);
  const DATA1 = tableFilterData.slice(pageNumber * rowsPerPage, pageNumber * rowsPerPage + rowsPerPage);
  const DATA2 = checkboxTableFilterData.slice(pageNumber * rowsPerPage, pageNumber * rowsPerPage + rowsPerPage);

  const formHandler = (e) => {
    e.preventDefault();
  };
  useEffect(() => {
    if (columnEvent === "CourseName") {
      const specificData = (Array.from(new Set(data.map((item => item["CourseName"])))));
      const uniqueData = (specificData.map((item) => { return { label: item } }));
      const checkedvalue = (uniqueData.map((elem) => {
        return { ...elem, isChecked: true };
      }))
      setCheckBoxData(uniqueData && checkedvalue)
    } else if (columnEvent === "SessionStartDate") {
      const specificData = (Array.from(new Set(data.map((item => item["SessionStartDate"])))))
      const uniqueData = (specificData.map((item) => { return { label: item } }))
      const checkedvalue = (uniqueData.map((elem) => {
        return { ...elem, isChecked: true };
      }))
      setCheckBoxData(uniqueData && checkedvalue)
    } else if (columnEvent === "SessionEndDate") {
      const specificData = (Array.from(new Set(data.map((item => item["SessionEndDate"])))))
      const uniqueData = (specificData.map((item) => { return { label: item } }))
      const checkedvalue = (uniqueData.map((elem) => {
        return { ...elem, isChecked: true };
      }))
      setCheckBoxData(uniqueData && checkedvalue)
    } else if (columnEvent === "Mode of Delivery") {
      const specificData = (Array.from(new Set(data.map((item => item["Mode of Delivery"])))))
      const uniqueData = (specificData.map((item) => { return { label: item } }))
      const checkedvalue = (uniqueData.map((elem) => {
        return { ...elem, isChecked: true };
      }))
      setCheckBoxData(uniqueData && checkedvalue)
    }
  }, [columnEvent])

  useEffect(() => {
    if (searchEvent !== '') {
      const uniquesearchingdata = checkboxData.filter((elem, inx) => inx === checkboxData.findIndex((elem1) => elem1.label === elem.label))
      const searchingdata = uniquesearchingdata.filter((item) => item.label.toLowerCase().includes(searchEvent.toLowerCase()))
      setSearchData(searchingdata)
      // console.log(searchingdata)
    } else {
      setSearchData([])
      // console.log("Hello")
    }
  }, [searchEvent, checkboxData])

  console.log(checkboxData)
  const handleChange = (e) => {
    const { name, checked } = e.target;
    if (name === "SelectAll") {
      let checkData = checkboxData.map((elem) => {
        return { ...elem, isChecked: checked, };
      });
      setCheckBoxData(checkData);
    } else {
      let checkData = checkboxData.map((elem) => {
        return (
          elem.label === name ? { ...elem, isChecked: checked } : elem)
      })
      setCheckBoxData(checkData);
    }
  };
  const handleSearch = (event) => {
    setSearchEvent(event.target.value);
  };
  // console.log(searchEvent.length)
  // useEffect(()=>{
  // if(searchEvent !== "" ){
  // const test = checkboxData.filter((item)=>item.label.includes(searchEvent))
  // console.log(test)
  // }else{
  //   console.log("something wrong")
  // }
  // },[])

  // console.log(searchData)
  // useEffect(() => {
  //   fetchData(selectedMonth.toLocaleLowerCase(), selectedYear);
  //   console.log("datat fetched")
  // }, [])

  const displaydata = () => {
    const isCheckedData = (checkboxData.filter((item) => item.isChecked));
    if (columnEvent === "CourseName") {
      const allData = data.filter((elem) => isCheckedData.some((elem1) => elem1.label === elem["CourseName"]))
      const checkfilter = allData.filter((item) => item.isChecked !== false)
      checkfilter.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
      setCheckboxTableFilterData(checkfilter)
      setResetTableData(false)
    } else if (columnEvent === "SessionStartDate") {
      const allData = data.filter((elem) => isCheckedData.some((elem1) => elem1.label === elem["SessionStartDate"]))
      const checkfilter = allData.filter((item) => item.isChecked !== false)
      checkfilter.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
      setCheckboxTableFilterData(checkfilter)
      setResetTableData(false)
    }
    else if (columnEvent === "SessionEndDate") {
      const allData = data.filter((elem) => isCheckedData.some((elem1) => elem1.label === elem["SessionEndDate"]))
      const checkfilter = allData.filter((item) => item.isChecked !== false)
      checkfilter.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
      setCheckboxTableFilterData(checkfilter)
      setResetTableData(false)
    }
    else if (columnEvent === "Mode of Delivery") {
      const allData = data.filter((elem) => isCheckedData.some((elem1) => elem1.label === elem["Mode of Delivery"]))
      const checkfilter = allData.filter((item) => item.isChecked !== false)
      checkfilter.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
      setCheckboxTableFilterData(checkfilter)
      setResetTableData(false)
    }
  }
  const dataFilterBtn = () => {
    const isCheckedData = (searchData.filter((item) => item.isChecked));
    if (columnEvent === "CourseName" && searchData !== "") {
      const FilteredData = data.filter((item) => isCheckedData.some((item1) => item1.label === item["CourseName"]))
      const checkFilterData = FilteredData.filter((item) => item.isChecked !== false)
      checkFilterData.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
      setTableFilterData(checkFilterData)
      setResetTableData(false)
    } else if (columnEvent === "SessionStartDate" && searchData !== "") {
      const FilteredData = data.filter((item) => isCheckedData.some((item1) => item1.label === item["SessionStartDate"]))
      const checkFilterData = FilteredData.filter((item) => item.isChecked !== false)
      checkFilterData.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
      setTableFilterData(checkFilterData)
      setResetTableData(false)
    } else if (columnEvent === "SessionEndDate" && searchData !== "") {
      const FilteredData = data.filter((item) => isCheckedData.some((item1) => item1.label === item["SessionEndDate"]))
      const checkFilterData = FilteredData.filter((item) => item.isChecked !== false)
      checkFilterData.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
      setTableFilterData(checkFilterData)
      setResetTableData(false)
    } else if (columnEvent === "Mode of Delivery" && searchData !== "") {
      const FilteredData = data.filter((item) => isCheckedData.some((item1) => item1.label === item["Mode of Delivery"]))
      const checkFilterData = FilteredData.filter((item) => item.isChecked !== false)
      checkFilterData.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
      setTableFilterData(checkFilterData)
      setResetTableData(false)
    }
  }
  console.log(columnEvent)
  const tableRestBtn = () => {
    setResetTableData(true)
    setSearchEvent('');
    setSearchData([]);
    setCheckBoxData(checkboxData.map((elem) => {
      return { ...elem, isChecked: true };
    }))
  }
  const resetBtn = () => {
    setSearchEvent('');
    setSearchData([]);
    setCheckBoxData(checkboxData.map((elem) => {
      return { ...elem, isChecked: true };
    }))
  }
  const tableData = (row, index) => {
    return (
      <tr key={index} >
        <td>{row["SId"]}</td>
        <td>{row["CourseName"]}</td>
        <td>{row["SessionStartDate"]}</td>
        <td>{row["SessionEndDate"]}</td>
        <td>{row["Mode of Delivery"]}</td>
        <td>{row["Category"]}</td>
        <td>{row["Duration"]}</td>
        {typeof row["Registration Link"] === 'string' && row["Registration Link"].startsWith('http') ?
          <td><a target="_blank" href={row["Registration Link"]}>Register</a></td> :
          <td>{row["Registration Link"]}</td>
        }
        <td>{row["Target Audience Level"]}</td>
      </tr>
    );
  }

  console.log(resetTableData)
  return (
    <>
      {data.length === 0 ? "" :
        <div className='table-topper-container'>
          <div className='reset-table-data' onClick={tableRestBtn}>Reset Filter</div>
          <TablePagination
            component="div"
            count={resetTableData === true ? data.length : tableFilterData.length > 0 ? tableFilterData.length : checkboxTableFilterData.length > 0 ? checkboxTableFilterData.length : data.length}
            page={pageNumber}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      }
      <table {...getTableProps()} className="mytable calendar-table" id="sortingTable">
        <thead className="thead-dark">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th style={{ width: column.width }}>
                  <div className="header-wrapper">
                    <span {...column.getHeaderProps()} >
                      {/* <span {...column.getHeaderProps()} onClick={onSortChange}>  */}
                      {/* {column.isSorted?(column.isSortedDesc ? <span>&#9662;</span>:<span>&#9652;</span>):""} */}
                      {column.render("Header")} </span>
                    {/* <i className={`fas fa-${sortTypes[currentSort].class}`} /> */}
                    {/* {column.render("HeaderName")} */}
                    {column.Img && <p className="filter-icon" onClick={() => { handleOpen(); setColumnEvent(column.render("HeaderName")) }} title="Filter">{column.Img}</p>}
                  </div>
                  <Modal
                    hideBackdrop
                    open={modelOpen}
                    onClose={handleClose}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    className="main-model-container"
                  >
                    <div className="main-model-wrapper">
                      <div className="model">
                        <input type="search" value={searchEvent} placeholder="Search Here.." className="search" onChange={handleSearch} />
                        <div className="model-data-container">
                          {/* checked={checkedData.filter((elem) => elem?.isChecked !== true).length < 1} */}
                          {searchEvent.length > 0 && searchData.length === 0 ?
                            <p className='no-records'>No Records Found</p> :
                            <>
                              <input type="checkbox" name="SelectAll" className="selectall" onChange={handleChange} checked={!checkboxData.some((elem) => elem?.isChecked !== true)} />
                              <lable for="selectall">Select All</lable>
                              {searchData.length > 0 ? ((searchData.map((searchField) => {
                                // console.log(searchField)
                                return (
                                  <>
                                    <div className="model-data">
                                      <input type="checkbox" id="searchcheck" name={searchField.label} onChange={handleChange} checked={searchField?.isChecked || false} />
                                      <lable for="searchcheck">{searchField.label}</lable>
                                    </div>
                                  </>
                                )
                              }))) :
                                checkboxData.map((field) => {
                                  return (
                                    <>
                                      <div className="model-data">
                                        <input type="checkbox" id={field.label} name={field.label} onChange={handleChange}
                                          checked={field?.isChecked || false}
                                        />
                                        <lable for={field.label}>{field.label}</lable>
                                      </div>
                                    </>
                                  );
                                })
                              }
                            </>
                          }
                        </div>
                      </div>
                      <div className="model-buttons">
                        <div className="reset-btn">
                          <button onClick={resetBtn}>Reset</button>
                        </div>
                        <div className="right-buttons">
                          <button onClick={() => { dataFilterBtn(); handleClose(); displaydata() }}>OK</button>
                          <button onClick={handleClose}>Cancel</button>
                        </div>
                      </div>
                    </div>
                  </Modal>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps}>
          {data.length === 0 ? <tr>
            <td colSpan={14}><Spinner animation="border" role="status">
              <span className="visually-hidden">No data found !</span>
            </Spinner></td></tr> : noData ? (
              <tr>
                <td colSpan={14}>
                  {inputChange.length > 0
                    ? "No data to display !"
                    : "Calendar Yet to be Published !"}
                </td>
              </tr>
            ) : (
            resetTableData === true ?
              DATA.map((row, index) => {
                return tableData(row, index);
              }) :
              tableFilterData.length > 0 ? (
                DATA1.map((row, index) => {
                  return tableData(row, index)
                })
              ) :
                checkboxTableFilterData.length > 0 ?
                  DATA2.map((row, index) => {
                    return tableData(row, index);
                  })
                  :
                  DATA.map((row, index) => {
                    return tableData(row, index);
                  })
          )}
        </tbody>
      </table>
      <div>
        {data.length === 0 ? "" :
          <div className="bottom-pagination">
            <TablePagination
              component="div"
              count={resetTableData === true ? data.length : tableFilterData.length > 0 ? tableFilterData.length : checkboxTableFilterData.length > 0 ? checkboxTableFilterData.length : data.length}
              page={pageNumber}
              onPageChange={handlePageChange}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        }
      </div>
    </>
  );
}

export default MonthlyTable1;